export const movies = [
  {
    id: "movie-deep-echo",
    type: "movie",
    title: "深海回声",
    originalTitle: "Echoes of the Deep",
    year: 2023,
    genres: ["科幻", "悬疑"],
    region: "中国大陆",
    director: "陆行舟",
    cast: ["沈亦白", "林昭", "温言", "程知远"],
    duration: "128 分钟",
    rating: 8.6,
    heat: 9820,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20art%20of%20a%20lone%20diver%20descending%20into%20a%20glowing%20deep%20dark%20blue%20ocean%20abyss%2C%20volumetric%20light%20beams%20piercing%20the%20water%2C%20mysterious%20floating%20particles%2C%20moody%20sci-fi%20thriller%20atmosphere%2C%20minimal%20composition%2C%20rich%20cinematic%20color%20grading&width=600&height=900&seq=poster-deep-echo&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20underwater%20scene%20of%20a%20submersible%20drifting%20above%20a%20bioluminescent%20trench%20in%20endless%20dark%20blue%20ocean%2C%20soft%20god%20rays%20from%20the%20surface%2C%20sci-fi%20mystery%20suspense%20mood%2C%20deep%20atmospheric%20grading&width=1280&height=720&seq=backdrop-deep-echo&orientation=landscape",
    tagline: "在声音消失的地方，真相开始回响。",
    summary:
      "一支深海探测队在马里亚纳海沟深处接收到一段不属于任何已知物种的规律回声，随着调查深入，队员们的记忆开始彼此错位。",
    synopsis: [
      "海洋声学工程师沈亦白受邀加入一支国际深海探测队，任务是打捞一台失联三年的无人潜航器。在四千八百米深处，设备意外捕捉到一段持续十七分钟的规律回声——它不属于任何已记录的地质活动，也不像任何已知生物的发声。",
      "随着回波被不断放大解析，探测队的通讯开始出现延迟，队员们开始梦见彼此的记忆。队医林昭发现，这些“借来的记忆”里藏着一场被官方抹去的沉船事故。当第五名成员决定下潜求证时，海面之上，一切都已不再是原来的样子。",
      "影片以密闭空间与深海压迫感构建悬疑张力，用声音设计代替视觉奇观，讲述一个关于记忆、隐瞒与真相回归的科幻谜题。",
    ],
  },
  {
    id: "movie-changan-night",
    type: "movie",
    title: "长安夜行",
    originalTitle: "Night Walk in Chang'an",
    year: 2021,
    genres: ["古装", "剧情"],
    region: "中国大陆",
    director: "郑清和",
    cast: ["顾南舟", "苏晚", "叶清欢"],
    duration: "142 分钟",
    rating: 8.9,
    heat: 9540,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20historical%20chinese%20movie%20poster%20of%20a%20lone%20figure%20in%20dark%20robes%20walking%20through%20a%20rain-soaked%20ancient%20changan%20street%20at%20night%2C%20hanging%20lanterns%2C%20mist%2C%20moody%20theatrical%20ancient%20china%20atmosphere%2C%20minimal%20composition&width=600&height=900&seq=poster-changan-night&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20view%20of%20ancient%20chinese%20imperial%20city%20at%20night%20with%20glowing%20red%20lanterns%20and%20stone%20paved%20streets%20after%20rain%2C%20low%20fog%2C%20dramatic%20period%20drama%20atmosphere%2C%20rich%20warm%20lighting&width=1280&height=720&seq=backdrop-changan-night&orientation=landscape",
    tagline: "一夜之间，长安城内无人入眠。",
    summary:
      "安史之乱前夕，一名负责记录夜巡的小吏在长安城中度过了一生中最长的一夜，也因此窥见了盛世之下正在崩裂的缝隙。",
    synopsis: [
      "天宝十四载，长安。小吏顾南舟的职责是每晚整理坊市夜巡记录，枯燥而卑微。上元灯节前夜，一桩看似寻常的失踪案，让他不得不走遍皇城、西市与曲江池畔，逐一核对每一条被涂改的记录。",
      "他遇见了被逐出教坊的舞姬苏晚，也遇见了奉命封锁消息的禁军。三个人在一夜之间交换了彼此的秘密：有人为理想奔走，有人为生存隐瞒，有人只是想让这座城市再多亮一盏灯。天亮时，盛世的帷幕被轻轻掀开了一角。",
      "影片以一昼夜的叙事结构勾勒一座城与一个时代，用细密的市井细节还原盛唐气象，也写下它落幕前最后的光。",
    ],
  },
  {
    id: "movie-against-light",
    type: "movie",
    title: "逆光而行",
    originalTitle: "Against the Light",
    year: 2022,
    genres: ["剧情", "励志"],
    region: "中国大陆",
    director: "韩澈",
    cast: ["白薇", "陆星河", "唐晓棠"],
    duration: "116 分钟",
    rating: 8.2,
    heat: 8760,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20in%20silhouette%20of%20a%20young%20runner%20sprinting%20toward%20a%20wall%20of%20golden%20backlight%2C%20long%20sharp%20shadows%2C%20inspirational%20drama%20mood%2C%20warm%20orange%20and%20dark%20blue%20contrast%2C%20minimal%20bold%20composition&width=600&height=900&seq=poster-against-light&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20shot%20of%20an%20empty%20running%20track%20at%20sunset%20with%20long%20shadows%20and%20a%20single%20distant%20runner%20silhouette%2C%20lens%20flare%2C%20warm%20uplifting%20drama%20atmosphere%2C%20golden%20hour%20grading&width=1280&height=720&seq=backdrop-against-light&orientation=landscape",
    tagline: "不是每一束光，都照得到终点。",
    summary:
      "一位因伤退役的短跑运动员回到县城中学执教，带着一群几乎被放弃的孩子，重新学习如何奔跑，也重新学习如何面对失败。",
    synopsis: [
      "白薇曾是省队最被看好的短跑新星，一次胫骨伤病让她的职业生涯戛然而止。回到故乡县城的中学，她被安排带一支连操场都借用的“杂牌”田径队。",
      "孩子们各有各的困境：有人要照顾生病的奶奶，有人被家里要求早点打工，有人只是从没被人相信过。白薇起初只想熬过一年，却在一次次起跑的枪声里，重新找回了自己曾经热爱的理由。",
      "影片没有廉价的奇迹，只有日复一日的训练、争议与和解，讲述普通人如何在逆光中，依然选择向前。",
    ],
  },
  {
    id: "movie-misty-capital",
    type: "movie",
    title: "雾都迷案",
    originalTitle: "The Misty Capital Case",
    year: 2020,
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    director: "黎望",
    cast: ["聂无双", "傅斯年", "宋知微"],
    duration: "124 分钟",
    rating: 8.4,
    heat: 8990,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%20of%20a%20lonely%20detective%20in%20a%20long%20coat%20standing%20beneath%20a%20foggy%20streetlamp%20in%20thick%20grey%20mist%2C%20rain%20slick%20cobblestones%2C%20noir%20mood%2C%20teal%20and%20amber%20tones%2C%20minimal%20composition&width=600&height=900&seq=poster-misty-capital&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20noir%20cinematic%20shot%20of%20a%20densely%20fogged%20old%20city%20alley%20with%20a%20single%20glowing%20streetlamp%20and%20wet%20reflective%20ground%2C%20mysterious%20crime%20drama%20atmosphere%2C%20cold%20blue%20tones%20with%20warm%20highlights&width=1280&height=720&seq=backdrop-misty-capital&orientation=landscape",
    tagline: "雾散之后，没有一个人是无辜的。",
    summary:
      "一具身份不明的尸体在雾都的老码头被发现，退休在即的老刑警与急于结案的年轻搭档，在层层迷雾中追查一桩跨越二十年的旧案。",
    synopsis: [
      "老刑警傅斯年距离退休只剩十七天，只想把手头的案卷整理干净。然而老码头打捞上来的一具无名尸体，把他重新拽回了二十年前那桩未能查清的失踪案。",
      "新来的搭档聂无双雷厉风行，一心想在年底考核前结案立功。两人从证物、口供到当年的气象记录，一寸一寸地重走旧路，却发现每一条线索的尽头，都通向同一个被所有人默许的沉默。",
      "影片以雾气笼罩的城市为背景，用近乎冷静的镜头讲述正义如何迟到，又如何终究到来。",
    ],
  },
  {
    id: "movie-time-fold",
    type: "movie",
    title: "时间折叠",
    originalTitle: "Folded Time",
    year: 2024,
    genres: ["科幻", "剧情"],
    region: "中国大陆",
    director: "陆星河",
    cast: ["程知远", "乔亦辰", "沈鹿"],
    duration: "135 分钟",
    rating: 8.7,
    heat: 9930,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20of%20concentric%20folding%20layers%20of%20a%20city%20skyline%20bending%20into%20itself%20like%20paper%2C%20surreal%20geometry%2C%20deep%20indigo%20and%20amber%20light%2C%20time%20travel%20concept%2C%20minimal%20elegant%20composition&width=600&height=900&seq=poster-time-fold&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20surreal%20cinematic%20landscape%20of%20a%20city%20reflected%20and%20folded%20into%20multiple%20overlapping%20time%20layers%2C%20floating%20architecture%2C%20deep%20blue%20night%20with%20amber%20glow%2C%20sci-fi%20concept%20art%20atmosphere&width=1280&height=720&seq=backdrop-time-fold&orientation=landscape",
    tagline: "我们把明天，折进了昨天。",
    summary:
      "一名物理学家发现实验室的引力波装置能够短暂折叠时间，为了挽回一场事故，他一次又一次回到同一个下午，却发现每一次修正都在制造新的代价。",
    synopsis: [
      "物理学家程知远在一次失败的实验中，意外观测到引力波装置可以让局部时间发生“折叠”——同一段十七分钟的午后，可以被重复地经历与改写。",
      "起初他只是想挽回助手乔亦辰在事故中受的伤。可每一次微小的修正，都会在别的时刻引发难以预料的连锁反应。当折叠次数逼近临界值，现实本身开始出现裂痕，记忆与现实不再一一对应。",
      "影片以严密的逻辑推演包裹一段关于遗憾与放手的故事，追问一个古老的问题：如果可以重来，我们真的愿意承担重来的代价吗？",
    ],
  },
  {
    id: "movie-mountain-wind",
    type: "movie",
    title: "山那边的风",
    originalTitle: "Wind Beyond the Mountain",
    year: 2019,
    genres: ["剧情", "文艺"],
    region: "中国大陆",
    director: "温言",
    cast: ["许砚", "苏晚", "陆星河"],
    duration: "108 分钟",
    rating: 8.1,
    heat: 7320,
    poster:
      "https://readdy.ai/api/search-image?query=delicate%20art%20house%20movie%20poster%20of%20terraced%20green%20rice%20fields%20on%20a%20misty%20mountain%20slope%20with%20a%20tiny%20solitary%20figure%2C%20soft%20morning%20light%2C%20serene%20melancholic%20literary%20mood%2C%20muted%20natural%20greens%20and%20golds%2C%20minimal%20composition&width=600&height=900&seq=poster-mountain-wind&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20serene%20cinematic%20view%20of%20layered%20misty%20mountains%20with%20terraced%20fields%20and%20a%20small%20village%2C%20soft%20diffused%20dawn%20light%2C%20quiet%20poetic%20atmosphere%2C%20muted%20earth%20tones&width=1280&height=720&seq=backdrop-mountain-wind&orientation=landscape",
    tagline: "离开的人，把风留在了山里。",
    summary:
      "一位在城市受挫的摄影师回到童年生活过的山村，用镜头重新认识那片土地，也重新认识沉默多年的父亲。",
    synopsis: [
      "摄影师许砚在城市里做了十年商业拍摄，直到一场官司让他失去了工作与住所。他回到出生的小山村，本打算只住一个夏天。",
      "父亲是村里的护林员，一辈子话不多。许砚用相机记录下逐渐空心化的村庄：废弃的教室、只剩老人的田埂、以及父亲每天巡山走过的那条路。镜头拉近，他才第一次真正看清那些被他当作理所当然的沉默。",
      "影片节奏舒缓，用一帧帧自然光下的空镜，讲述一段关于故乡、离别与理解的和解。",
    ],
  },
  {
    id: "movie-wild-convoy",
    type: "movie",
    title: "荒野车队",
    originalTitle: "The Wild Convoy",
    year: 2023,
    genres: ["动作", "冒险"],
    region: "中国大陆",
    director: "韩澈",
    cast: ["黎望", "郑清和", "唐晓棠", "乔亦辰"],
    duration: "126 分钟",
    rating: 7.9,
    heat: 8450,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20action%20movie%20poster%20of%20a%20rugged%20convoy%20of%20trucks%20racing%20across%20a%20vast%20desert%20highway%20kicking%20up%20dust%20clouds%2C%20dramatic%20sunset%20sky%2C%20high%20energy%20adventure%20mood%2C%20orange%20dust%20and%20deep%20blue%20shadows%2C%20bold%20minimal%20layout&width=600&height=900&seq=poster-wild-convoy&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20shot%20of%20a%20line%20of%20dusty%20trucks%20speeding%20along%20an%20endless%20desert%20road%20at%20golden%20sunset%2C%20long%20dust%20trails%2C%20dramatic%20wide%20landscape%2C%20action%20adventure%20atmosphere%20with%20warm%20tones&width=1280&height=720&seq=backdrop-wild-convoy&orientation=landscape",
    tagline: "在这条路上，活着就是方向。",
    summary:
      "一支运送补给的车队在穿越无人区时遭遇突袭，司机们必须在不熟悉的地形中，靠彼此信任把货物和性命一起送到终点。",
    synopsis: [
      "车队领队老黎接下一单几乎没人愿意接的高价运输：把一批紧急补给送进被风沙封锁的西部矿区。七辆卡车、十余名司机，出发时谁也没打算交出真心。",
      "进入无人区第二天，车队遭遇不明势力的拦截，导航失灵、油料告急。有人想弃货保命，有人坚持完成任务。在一次次沙暴与追逐中，这群临时拼凑起来的人，被迫成为真正的伙伴。",
      "影片以实景拍摄的公路追逐和广袤地貌为看点，讲述一群人如何在绝境里守住承诺。",
    ],
  },
  {
    id: "movie-stardust-traveler",
    type: "movie",
    title: "星尘旅人",
    originalTitle: "Stardust Traveler",
    year: 2024,
    genres: ["科幻", "爱情"],
    region: "中国大陆",
    director: "陆星河",
    cast: ["沈鹿", "温言", "白薇"],
    duration: "119 分钟",
    rating: 8.3,
    heat: 9120,
    poster:
      "https://readdy.ai/api/search-image?query=romantic%20sci-fi%20movie%20poster%20of%20two%20distant%20silhouettes%20reaching%20toward%20each%20other%20across%20a%20glowing%20river%20of%20stars%20in%20dark%20space%2C%20nebula%20colors%2C%20tender%20melancholic%20atmosphere%2C%20deep%20indigo%20with%20soft%20golden%20highlights%2C%20minimal%20composition&width=600&height=900&seq=poster-stardust-traveler&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20space%20scene%20of%20a%20lone%20small%20spacecraft%20drifting%20through%20a%20vast%20colorful%20nebula%20with%20glowing%20star%20clusters%2C%20quiet%20romantic%20sci-fi%20mood%2C%20deep%20blue%20and%20violet%20with%20warm%20gold%20accents&width=1280&height=720&seq=backdrop-stardust-traveler&orientation=landscape",
    tagline: "光要走一百年，我走一辈子。",
    summary:
      "一名深空信标维护员在宇宙边缘独自值班，靠一段延迟百年的通讯，与地球上一名素未谋面的天文学学生产生了跨越时空的联系。",
    synopsis: [
      "沈鹿是深空信标站的唯一维护员，驻守在距地球数光年外的荒凉星域。漫长的值班岁月里，他唯一的陪伴，是来自地球的、延迟了上百年的通讯数据流。",
      "在一批迟到百年的档案中，他发现了一名天文学学生温言留下的观测笔记与私人留言。他开始一封一封地回复，明知这些讯息抵达时，对方早已不在人世。",
      "影片以孤独的宇宙为背景，讨论一种极致形式的爱：它不追求回应，只追求被写下。",
    ],
  },
  {
    id: "movie-corner-food",
    type: "movie",
    title: "街角食光",
    originalTitle: "Corner Food Stories",
    year: 2021,
    genres: ["喜剧", "美食"],
    region: "中国大陆",
    director: "唐晓棠",
    cast: ["宋知微", "乔亦辰", "顾南舟"],
    duration: "104 分钟",
    rating: 8.0,
    heat: 7680,
    poster:
      "https://readdy.ai/api/search-image?query=warm%20cozy%20food%20drama%20movie%20poster%20of%20a%20tiny%20street%20corner%20restaurant%20glowing%20at%20night%20with%20steaming%20bowls%20of%20noodles%2C%20cheerful%20hanging%20lights%2C%20appetizing%20warm%20tones%2C%20comedy%20feel-good%20atmosphere%2C%20minimal%20composition&width=600&height=900&seq=poster-corner-food&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20warm%20cinematic%20view%20of%20a%20small%20bustling%20street%20food%20stall%20at%20night%20with%20steam%2C%20warm%20lantern%20light%2C%20appetizing%20dishes%20on%20a%20counter%2C%20cozy%20feel-good%20atmosphere%2C%20rich%20amber%20tones&width=1280&height=720&seq=backdrop-corner-food&orientation=landscape",
    tagline: "再难的日子，也要好好吃饭。",
    summary:
      "一家开在街角、屡屡濒临倒闭的小面馆，迎来几位各有心事的店员和形形色色的客人，用一道道家常菜串起市井人生。",
    synopsis: [
      "老板娘宋知微继承了父亲留下的小面馆，生意惨淡，眼看就要关门。她招来两个“问题员工”：一个是被裁员的前白领乔亦辰，一个是想学厨却总闯祸的年轻人顾南舟。",
      "面馆每天准时开门，迎来加班到深夜的程序员、失恋的姑娘、拌嘴的老夫妻。每一碗面背后都有一段故事，而三个原本互不相干的人，也在一餐一饭之间，慢慢找回了生活的滋味。",
      "影片用轻喜剧的节奏和满屏的烟火气，讲述最朴素的道理：好好吃饭，就是好好生活。",
    ],
  },
  {
    id: "movie-silent-testimony",
    type: "movie",
    title: "沉默的证词",
    originalTitle: "The Silent Testimony",
    year: 2022,
    genres: ["悬疑", "律政"],
    region: "中国大陆",
    director: "郑清和",
    cast: ["傅斯年", "白薇", "聂无双"],
    duration: "131 分钟",
    rating: 8.5,
    heat: 8890,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20legal%20thriller%20movie%20poster%20of%20a%20solemn%20courtroom%20with%20a%20single%20empty%20witness%20chair%20under%20a%20beam%20of%20cold%20light%2C%20dark%20wood%20interior%2C%20tense%20dramatic%20mood%2C%20deep%20blue%20and%20amber%20contrast%2C%20minimal%20composition&width=600&height=900&seq=poster-silent-testimony&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20dramatic%20cinematic%20view%20of%20an%20old%20courtroom%20interior%20with%20tall%20windows%20casting%20long%20shadows%20on%20empty%20benches%2C%20tense%20legal%20drama%20atmosphere%2C%20cold%20blue%20light%20with%20warm%20wood%20tones&width=1280&height=720&seq=backdrop-silent-testimony&orientation=landscape",
    tagline: "有些话，说出来就是一辈子。",
    summary:
      "一名年轻律师接手一桩几乎没有胜算的旧案，唯一的证人在十年前选择了永久沉默，而真相藏在所有人都读过、却无人相信的那份笔录里。",
    synopsis: [
      "年轻律师白薇接下了一桩被业内视为“死案”的申诉：一名男子被指控在十年前犯下重罪，唯一的目击证人却在庭后彻底沉默，从此再未开口。",
      "在翻阅上万页卷宗后，白薇注意到一份被反复忽略的笔录细节——它与所有人的口供都对得上，却与最终的判决相矛盾。为了重新唤醒那位沉默的证人，她必须面对比案件更复杂的现实：一个已经被时间封存的选择。",
      "影片在法庭辩论的紧张节奏中，讨论法律、良知与沉默之间的重量。",
    ],
  },
];